module.exports = __webpack_public_path__ + "img/kaizech.c03ffa1a.png";